// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".add-link[data-v-4878d531] {\n  cursor: pointer;\n  color: var(--main-blue);\n  font-size: 13px;\n  margin-top: 5px;\n}\n.error-msg[data-v-4878d531] {\n  -webkit-box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.1);\n          box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.1);\n  background: #ffffe8;\n  padding: 20px;\n  font-size: 12px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
